import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Select } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const POOL_CATEGORIES = ['DIET', 'EXERCISE', 'WATER', 'CHECK_IN'];
const DIFFICULTIES = ['EASY', 'NORMAL', 'HARD'];
const TRIGGERS = [
  'FOOD_LOG_CREATED',
  'WATER_LOG_CREATED',
  'WORKOUT_COMPLETED',
  'APP_CHECK_IN',
];

const LANG_FIELDS = [
  { key: 'title', label: 'Title', required: true },
  { key: 'description', label: 'Description', textarea: true, rows: 2 },
];

export const GamificationTaskEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'gamification-tasks' });

  return (
    <Edit resource="gamification-tasks" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Pool Category" name="poolCategory" rules={[{ required: true }]}>
          <Select options={POOL_CATEGORIES.map((v) => ({ value: v, label: v }))} />
        </Form.Item>
        <Form.Item label="Difficulty" name="difficulty" rules={[{ required: true }]}>
          <Select options={DIFFICULTIES.map((v) => ({ value: v, label: v }))} />
        </Form.Item>
        <Form.Item label="Trigger Event" name="triggerEvent" rules={[{ required: true }]}>
          <Select options={TRIGGERS.map((v) => ({ value: v, label: v }))} />
        </Form.Item>
        <Form.Item label="Target Value" name="targetValue" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item label="Reward Coins" name="rewardCoins">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Reward XP" name="rewardXp">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Weight" name="weight">
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item label="Points Label" name="pointsLabel">
          <Input />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder">
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Reset Daily" name="resetDaily" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
